












import {
  Component,
  Vue,
} from 'vue-property-decorator';

import AvailabilityBlock from '@/components/AvailabilityBlock.vue';

import ProductFeature from './ProductFeature';

@Component({
  components: {
    AvailabilityBlock,
  },
  filters: {
    formatRestockDate: (d: Date) => (
      d.toLocaleString('zh-TW', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      })
    ),
  },
})
export default class AvailabilityFeature extends ProductFeature {
  get inventory() {
    return this.variant.inventory;
  }
}

